import { render } from "./ProgramAssigneeDialog.vue?vue&type=template&id=18d0d938&scoped=true"
import script from "./ProgramAssigneeDialog.vue?vue&type=script&lang=js"
export * from "./ProgramAssigneeDialog.vue?vue&type=script&lang=js"

import "./ProgramAssigneeDialog.vue?vue&type=style&index=0&id=18d0d938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d0d938"]])

export default __exports__